import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { View } from '../compiler'
import { colors, typoStyles } from '../constants'
import { useTranslationContext } from '../context/general-translations'
import BulletPoints from './BulletPoints'
import DiscussionQuestions from './DiscussionQuestions'
import CoordinateSystem from './graphs/CoordinateSystem'
import MarkdownText from './MarkdownText'

const CulturalFit = ({
  style = {},
  language,
  culturalFitTexts = {},
  companyCultureScores = {},
  challenge,
  teamInputValues,
  withDetails = false,
  withCompanyIcon = false,
  isLoading
}) => {
  const { tGeneral } = useTranslationContext()
  const { text, bullet_points, discussion_questions } = culturalFitTexts

  return (
    <View style={style}>
      <View
        style={{
          borderWidth: 1,
          borderColor: colors.lightGrey,
          borderRadius: 8
        }}
      >
        {withDetails && (
          <View style={{ padding: 24 }}>
            <MarkdownText
              style={[typoStyles.T2Black, { color: colors.rockGrey }]}
            >
              {isLoading ? (
                <Skeleton width={200} />
              ) : (
                <>
                  {tGeneral('method_label')}
                  <MarkdownText style={typoStyles.ButtonBlue}>
                    {challenge.title[language]}
                  </MarkdownText>
                </>
              )}
            </MarkdownText>
          </View>
        )}
        {isLoading ? (
          <View style={{ padding: 24 }}>
            <Skeleton height={300} />
          </View>
        ) : (
          <CoordinateSystem
            companyCultureScores={companyCultureScores}
            teamInputValues={teamInputValues}
            withCompanyIcon={withCompanyIcon}
          />
        )}
        {text && (
          <View style={{ backgroundColor: colors.lightPaleGrey, padding: 24 }}>
            <MarkdownText style={typoStyles.T1Black}>
              {isLoading ? <Skeleton count={3} /> : text}
            </MarkdownText>
            {!isLoading && withDetails && (
              <>
                <BulletPoints
                  style={{ marginTop: 24 }}
                  bulletPoints={bullet_points}
                />
                <DiscussionQuestions
                  style={{ marginTop: 24 }}
                  questions={discussion_questions}
                />
              </>
            )}
          </View>
        )}
      </View>
    </View>
  )
}

export default CulturalFit
